// GENERATED by scripts/build-icons.mjs from icons/file-down.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const FileDown = createIcon('file-down', [
  ['path', { d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" }],
  ['path', { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
  ['path', { d: "M12 18v-6" }],
  ['path', { d: "m9 15 3 3 3-3" }],
])
